import React from "react";
import styles from "./download-button.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAndroid, faApple } from "@fortawesome/free-brands-svg-icons";
import { useQueryParam } from "gatsby-query-params";

export default ({ btnConfig }) => {
  const { os } = btnConfig;
  const referrer = useQueryParam("referrer", null);

  let qs = "";
  if (referrer !== null) {
    qs = os === "android" ? `&referrer=${referrer}` : `?referrer=${referrer}`;
  }

  return (
    <a
      className={styles.btn}
      style={{ backgroundColor: btnConfig.bgColor, color: btnConfig.fgColor }}
      href={`${btnConfig.href}${qs}`}
      target={btnConfig.target}
      rel="noopener noreferrer"
    >
      <div className="inline-block flex-grow-0 mr-2">
        <FontAwesomeIcon
          size="2x"
          icon={os === "android" ? faAndroid : faApple}
        />
      </div>
      <div className="inline-block flex-initial text-sm sm:text-base">
        {btnConfig.text}
      </div>
    </a>
  );
};
